<div class="agpr-mentionTranslationTab">
    <agpr-tabs
        [selectedTabIndex]="selectedTabIndex"
        (selectedTabIndexChange)="tabIndexChange($event)"
        [tabsHeadingLevel]="tabsHeadingLevel"
    >
        <agpr-tab
            [id]="'translate.originalTab'"
            [heading]="'translate.original'"
        >
        </agpr-tab>
        <agpr-tab
            [id]="'translate.translatedTab'"
            [heading]="'translate.translated'"
            [disabled]="!mention?.translation && !mention?.translating"
        >
        </agpr-tab>
    </agpr-tabs>
</div>
